import { useEffect, useRef } from 'react';
import type { DebouncedFunc } from 'lodash-es';
import { debounce } from 'lodash-es';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function useDebouncedFunction<T extends (...args: any[]) => any>(
	callback: T,
	waitMs: number,
): DebouncedFunc<T> {
	const debounceRef = useRef<DebouncedFunc<T>>(NoOpDebounced);

	useEffect(() => {
		if (debounceRef.current === NoOpDebounced) {
			debounceRef.current = debounce(callback, waitMs);
		}
		return () => {
			// Cancel any pending debounce on unmount
			if (debounceRef.current) {
				debounceRef.current.cancel();
			}
		};
	}, [callback, waitMs]);

	return debounceRef.current;
}

const NoOp = () => {};
const NoOpDebounced = debounce(NoOp, 0);
